<template>
    <section class="container">
      <div class="route">
        {{$locales.ajustes.ajustes}} > {{$locales.ajustes.datospersonales.datospersonales}} > {{$locales.ajustes.datospersonales.modificardatos}}
      </div>
      <div class="sidebar">
        <span class="principal">
          <span class="icon">J  </span>{{$locales.ajustes.ajustes}}
        </span>
        <ul>
          <li @click="toggle">
            <span class="sidebar-item"><span class="arrow">&#9660;</span>{{$locales.ajustes.alertas.alertas}}</span>
                <router-link to="/onesaitConfirmingProviders/ajustes/alertas/facturas"  class="link" v-if="active">
                  {{$locales.ajustes.alertas.facturas}}
                </router-link>
          </li>
          <li  @click="toggle2">
                <span class="sidebar-item">
                  <span class="arrow">&#9660; </span>{{$locales.ajustes.seguridadclaves.seguridadclaves}}
                </span>
                <router-link to="/onesaitConfirmingProviders/ajustes/modificar-contrasena"  class="link" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarpassword}}
                </router-link>
                <router-link to="/onesaitConfirmingProviders/ajustes/modificar-claveFirma"  class="link" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarclavefirma}}
                </router-link>
          </li>
          <li @click="toggle3">
                 <span class="sidebar-item">
                  <span class="arrow">&#9660; </span>{{$locales.ajustes.datospersonales.datospersonales}}
                </span>
                <span @click="refresh"><router-link to="/onesaitConfirmingProviders/ajustes/datos-personales/modificar-datos"  class="link-active" v-if="active3">
                  {{$locales.ajustes.datospersonales.modificardatos}}
                </router-link></span>
          </li>
        </ul>
      </div>
      <div class="window">
        <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Operación realizada con éxito</h3>
        </div>
        <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
        </div>
        <h1>{{$locales.ajustes.datospersonales.modificardatos}}</h1>
          <div class="form-group-reduced">
            <form class="window-form" @submit.prevent="aceptar">
              <br><br>
                  <h3>Datos identificativos</h3><hr>
                  <br>
                  <label for="nombreUsuario">* Nombre usuario/empresa</label>
                  <input class = "inputComponentDisabled reducido" disabled type="text" id="nombreUsuario" name="nombreUsuario" autocomplete="off"  v-model="model.nombreUsuario" />
                  
                  <label for="nifCif">* NIF/CIF</label>
                  <input class = "inputComponentDisabled reducido" disabled type="text" id="nifCif" name="nifCif" autocomplete="off"  v-model="model.nifCif"/>
                  <br><br>
                  <div class="row">
                    <div class="elemento">
                      <h3>Datos domiciliarios</h3>
                    </div>
                    <div class="elementoBotones">
                      <span class="icon editarnormal centrado" :hidden="isBeforeSign || editar1" @click="toggleeditar(1,false)">P
                      </span>
                      <span class="icon editarnormal" :hidden="!editar1" @click="aceptar(1)">l
                      </span>
                      <span  :hidden="!editar1" @click="toggleeditar(1,true)" class="icon editarrojo separacion">n
                      </span>
                    </div>
                  </div>
                  <hr>
                  <br>
                    <!-- COMBO -->
                    
                  <label for="estado">Tipo de vía</label>
                  <md-field :class = "editar1 ? 'reducido' : 'comboDisabled reducido'" id="anchoCombo">
                    <md-select :class = "editar1 ? 'combo' : 'comboDisabled'" :disabled="!editar1" v-model="model.tipoVia" name="tipoVia" id="tipoVia" placeholder="Seleccione una opción">
                      <md-option value="AV">Avenida</md-option>
                      <md-option value="CL">Calle</md-option>
                      <md-option value="PZ">Plaza</md-option>
                    </md-select>
                  </md-field>
                      <label for="direccion">Nombre de la vía</label>
                      <input :class = "editar1 ? 'inputComponent reducido' : 'inputComponentDisabled reducido'" :disabled="!editar1" type="text" id="direccion" name="direccion" autocomplete="off" v-model="model.direccion"/>
                   
                  <label for="numCallePlaza">Número</label>
                      <input :class = "editar1 ? 'inputComponent reducido' : 'inputComponentDisabled reducido'" :disabled="!editar1" type="text" id="numCallePlaza" name="numCallePlaza" autocomplete="off" v-model="model.numCallePlaza"/>
                    
                      <label for="codPostal">Código postal</label>
                      <input :class = "editar1 ? 'inputComponent reducido' : 'inputComponentDisabled reducido'" :disabled="!editar1" type="text" id="codPostal" name="codPostal" autocomplete="off" v-model="model.codPostal" />
                      <!-- Posibles errores de validacion -->
                      <div class="error" v-if="editar1 && (!$v.model.codPostal.maxLength)">El campo debe tener como máximo 5 cifras</div>
                      <div class="error" v-if="editar1 && (!$v.model.codPostal.numeric)">El campo debe ser numérico</div>
                    
                    
                      <label for="localidad">Localidad</label>
                      <md-field :class = "editar1 ? 'reducido' : 'comboDisabled reducido'" id="anchoCombo">
                        <md-select :class = "editar1 ? 'combo' : 'comboDisabled'" :disabled="!editar1" v-model="model.localidad" name="localidad" id="localidad" placeholder="Seleccione una localidad">
                          <md-option v-for="ciudad in listaCiudades" v-bind:key="ciudad.id" :value="ciudad.id">{{ciudad.name}}</md-option>
                        </md-select>
                      </md-field>
                   
                      <label for="provincia">Provincia</label>
                      <md-field :class = "editar1 ? 'reducido' : 'comboDisabled reducido'" id="anchoCombo">
                        <md-select :class = "editar1 ? 'combo' : 'comboDisabled'" :disabled="!editar1" v-model="model.provincia" name="provincia" id="provincia" placeholder="Seleccione una provincia">
                          <md-option v-for="prov in listaProvincias" v-bind:key="prov.id" :value="prov.id">{{prov.name}}</md-option>
                        </md-select>
                      </md-field>
                  <br><br>
                  <h3>Datos de contacto</h3><hr>
                  <br>
                  <div class="row2" id="modificarDatos">
                    <div class="elemento" id="modificarDatos">
                      <label for="telefono">* Teléfono</label>
                      <input :class = "'inputComponentDisabled'" :disabled=true type="text" id="telefono" name="telefono" autocomplete="off" v-model="model.telefono"/>
                      <!-- Posibles errores de validacion -->
                      <div class="error" v-if="editar3 && ($v.model.telefono.required) && (!$v.model.telefono.maxLength)">El campo debe tener como máximo 9 cifras</div>
                      <div class="error" v-if="editar3 && ($v.model.telefono.required) && (!$v.model.telefono.numeric)">El campo debe ser numérico</div>
                      <div class="error" v-if="editar3 && (!$v.model.telefono.required)">Este campo es obligatorio</div>
                    </div>
                    <div class="elementoBotones">
                      <!--<span class="icon editarnormal centrado" :hidden="isBeforeSign || editar3" @click="toggleeditar(3,false)">P
                      </span>
                      <span class="icon editarnormal" :hidden="!editar3" @click="aceptar(3)">l
                      </span>
                      <span  :hidden="!editar3" @click="toggleeditar(3,true)" class="icon editarrojo separacion">n
                      </span>-->
                    </div>
                  </div>
                  
                  <div class="row2" id="modificarDatos">
                    <div class="elemento" id="modificarDatos">
                        <label for="emailNotiPago">* Email notificación pago</label>
                        <input :class = "'inputComponentDisabled'" :disabled="true" type="text" id="emailNotiPago" name="emailNotiPago" autocomplete="off" v-model="model.emailNotiPago"/>
                        <!-- Posibles errores de validacion -->
                        <div class="error" v-if="editar4 && ($v.model.emailNotiPago.required) && (!$v.model.emailNotiPago.email)">El campo debe tener formato email</div>
                        <div class="error" v-if="editar4 && (!$v.model.emailNotiPago.required)">Este campo es obligatorio</div>
                    </div>
                    <div class="elementoBotones">
                      <!--<span class="icon editarnormal centrado" :hidden="isBeforeSign || editar4" @click="toggleeditar(4,false)">P
                      </span>
                      <span class="icon editarnormal" :hidden="!editar4" @click="aceptar(4)">l
                      </span>
                      <span  :hidden="!editar4" @click="toggleeditar(4,true)" class="icon editarrojo separacion">n
                      </span>-->
                    </div>
                  </div>
                 
                  <div class="row2" id="modificarDatos">
                    <div class="elemento" id="modificarDatos">
                      <label for="fax">Teléfono fijo</label>
                      <input :class = "editar5 ? 'inputComponent' : 'inputComponentDisabled'" :disabled="!editar5" type="text" id="fax" name="fax" autocomplete="off" v-model="model.fax"/>
                      <!-- Posibles errores de validacion -->
                      <div class="error" v-if="editar5 && (!$v.model.fax.maxLength)">El campo debe tener como máximo 9 cifras</div>
                      <div class="error" v-if="editar5 && (!$v.model.fax.numeric)">El campo debe ser numérico</div>
                    </div>
                    <div class="elementoBotones">
                      <span class="icon editarnormal centrado" :hidden="isBeforeSign || editar5" @click="toggleeditar(5,false)">P
                      </span>
                      <span class="icon editarnormal" :hidden="!editar5" @click="aceptar(5)">l
                      </span>
                      <span  :hidden="!editar5" @click="toggleeditar(5,true)" class="icon editarrojo separacion">n
                      </span>
                    </div>
                  </div>
                  
                  
                  
            <div v-if=datosOTP>
              <OTPComponent :params="params" :datosOTP="datosOTP" @rellenarDatos="callBackRellenarDatos" :llamada="llamada" @aceptar="callBackAceptarOTP" @cancelar="callBackCancelar"></OTPComponent>
            </div>
            <!-- Boton aceptar para antes de realizar la consulta, este no tiene validacion -->
            <input class="btnPrimary" type="button" @click="pedirFIRMA" value="Modificar datos" v-if="!consultaRealizada && beforeSubmit">
            </form>
          </div>      
          <div v-if=datosFirma>
             <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @rellenarDatos="callBackRellenarDatos" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
          </div>    
      </div>
    </section>
</template>

<script>
import { required,maxLength,numeric,email } from "vuelidate/lib/validators";
import ModifyData from '../models/ModifyData';
import SignatureComponent from './SignatureComponent';
import OTPComponent from './OTPComponent';  
export default {
    name : 'ModifyDataComponent',
    data(){
      return{  
        isBeforeSign:true,
        active: false,
        active2: false,
        editar1:false,
        editar3:false,
        editar4:false,
        editar5:false,
        active3: true,
        datosDomicilio:null, //este alberga los codigos de ciudad y provincia que pertenencen a otra tx
        submitted: false,
        consultaRealizada:false, //false por defecto hasta que se haya realizado completamente la consulta
        listaCiudades:null, //esta sera la lista de ciudades que salgan tras introducir un codigo postal
        listaProvincias:null, //esta sera la lista de provincias que salgan
        beforeSubmit: true,
        mensajeError: null,
        params: null,
        datosFirma: null,
        datosOTP: null,
        confirmacion: null,
        llamada: null,
        resultado:null,    
        model : new ModifyData() //nuestro model contiene los datos de Entrada, es como el modelCriteria de TF
      }
    },
    components: { 
      SignatureComponent,
      OTPComponent
    },
    computed: {
      watcherCodPostal() { //informa de manera continua el codigo postal del modelo al watcher, es imprescindible porque el cp esta dentro de un modelo de datos
        return this.model.codPostal;
      }
    },
     created: function(){ //llamada a /api-customers/customers
      const ventana=this;
      const baseURI = '/api-customers/customers';
      let loader = this.$loading.show();
 
           
      this.$http.get(baseURI)
      .then((result) => {
        this.resultado=result;
        this.model.nombreUsuario=(result.data.data.typePhysicalPerson=="J") ? result.data.data.bussinesName : (result.data.data.name+(result.data.data.surname==null ? "" : " "+result.data.data.surname)+(result.data.data.secondSurname==null ? "" : " "+result.data.data.secondSurname));
        this.model.nifCif=result.data.data.legalDocument.id;
        this.model.tipoVia=result.data.data.addresses[0].streetType.id;
        this.model.direccion=result.data.data.addresses[0].streetName;
        this.model.numCallePlaza=result.data.data.addresses[0].streetNumber;
        this.model.codPostal=result.data.data.addresses[0].postcode;
        this.model.telefono=result.data.data.contactInfo.mobileNumber;
        this.model.fax=result.data.data.contactInfo.phoneNumber;
        this.model.emailNotiPago=result.data.data.contactInfo.email;

        this.pedirFIRMA();

      })
      .catch(error => {
        if(error.response){
          var codError = null; 
          var descError = null;
          if(error.response.status != 200) {
            if(error.response.data.result.errors[0].errorCode == "096H") {
              this.datosFirma = error.response.data.result.errors[0].info;
              this.beforeSubmit = false;
            } else {
              codError = error.response.data.result.errors[0].errorCode;
              descError = error.response.data.result.errors[0].errorDescription;
              this.mensajeError = codError + " - " + descError;
              this.confirmacion = "KO";
              loader.hide();
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
        }else{ //si no, por defecto
          ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
          ventana.confirmacion='KO';
        }
      })     
      .then(function () {
        loader.hide();
      });
    },
    validations : {
      model : {
        nombreUsuario: {
          required
        },
        nifCif: {
          required
        },
         codPostal: {
          maxLength: maxLength(5),
          numeric
        },
         telefono: {
          required,
          maxLength: maxLength(9),
          numeric
        },
         fax: {
          maxLength: maxLength(9),
          numeric
        },
        emailNotiPago: {
          required,
          email
        },
      }
    },
    methods: {
      refresh(){ //esto tiene la funcion de refrescar el componente cuando volvemos a clickar sobre el en las NavigationBars
        this.$parent.keyRefresh+=1; //al cambiar la key de esta section que lo abarca todo, vue dispara un update
      },
      cargarPoblacion(codPostal){ //carga las poblaciones en el combo poblacion, segun el codigo postal introducido
        const ventana=this;
        const baseURI = '/api-customers/customers/dataCatalogs/cities/'+codPostal;
        let loader = this.$loading.show();
        this.$http.get(baseURI)
        .then((result) => {
          this.listaCiudades=result.data.data; //obtenemos las ciudades con ese codigo postal y las cargamos
        })
        .catch(error => {
          if(error.response){
            var codError = null; 
            var descError = null;
            if(error.response.status != 200) {
                codError = error.response.data.result.errors[0].errorCode;
                descError = error.response.data.result.errors[0].errorDescription;
                this.mensajeError = codError + " - " + descError;
                this.confirmacion = "KO";
            }else{ //si no, por defecto
              ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
              ventana.confirmacion='KO';
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
          window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
        })     
        .then(function () {
          loader.hide();
        });
      },
      cargarProvincias(){ //carga las poblaciones en el combo poblacion, segun el codigo postal introducido
        const ventana=this;
        const baseURI = '/api-customers/customers/dataCatalogs/provinces';
        let loader = this.$loading.show();
        this.$http.get(baseURI)
        .then((result) => {
          this.listaProvincias=result.data.data; //obtenemos las provincias
        })
        .catch(error => {
          if(error.response){
            var codError = null; 
            var descError = null;
            if(error.response.status != 200) {
                codError = error.response.data.result.errors[0].errorCode;
                descError = error.response.data.result.errors[0].errorDescription;
                this.mensajeError = codError + " - " + descError;
                this.confirmacion = "KO";
            }else{ //si no, por defecto
              ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
              ventana.confirmacion='KO';
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
          window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
        })     
        .then(function () {
          loader.hide();
        });
      },
      consultarDatosDomicilio(){ //obtiene los codigos de localidad y provincia de la persona
        const ventana=this;
        const baseURI = '/api-customers/customers/addresses';
        let loader = this.$loading.show();
        this.$http.get(baseURI)
        .then((result) => {
          //primero los almacenamos en una variable global
          this.datosDomicilio={
            provincia:result.data.data[0].provinceId,
            localidad:result.data.data[0].cityId,
            direccion:result.data.data[0].addressId
          }
          //seteamos
          this.model.provincia=this.datosDomicilio.provincia;
          this.model.localidad=this.datosDomicilio.localidad;
        })
        .catch(error => {
          if(error.response){
            var codError = null; 
            var descError = null;
            if(error.response.status != 200) {
                codError = error.response.data.result.errors[0].errorCode;
                descError = error.response.data.result.errors[0].errorDescription;
                this.mensajeError = codError + " - " + descError;
                this.confirmacion = "KO";
            }else{ //si no, por defecto
              ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
              ventana.confirmacion='KO';
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
          window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
        })     
        .then(function () {
          loader.hide();
        });
      },
      callBackAceptarOTP(confirmacion, mensaje, codError){
        this.beforeSubmit = true;
        this.confirmacion = confirmacion;
        this.submitted=false;
        this.mensajeError = mensaje;
        if(confirmacion == "OK") {
          this.callBackCancelar(); //son las instrucciones necesarias para resetear la pantalla como al comienzo
          window.scrollBy(0, -window.innerHeight);
        } else {
          window.scrollBy(0, -window.innerHeight);
          if(codError == '095H') { //clave otp incorrecta
          }else if (codError == '089H') {
            this.datosOTP = null;
            this.mensajeError = 'Usuario bloqueado';
            window.scrollBy(0, -window.innerHeight);
          }else{ //si es un error distinto del bloqueo de usuario o clave otp incorrecta, la otp se comporta como si la cancelaramos
            this.callBackCancelar(true);
          }
        }
      },
     callBackAceptar(confirmacion, mensaje, otp, codError){
      this.confirmacion = confirmacion;
      this.mensajeError = mensaje;
      this.submitted=false;
      this.beforeSubmit=true;
      if(confirmacion == "OK") {
          this.callBackCancelar(); //son las instrucciones necesarias para resetear la pantalla como al comienzo
          window.scrollBy(0, -window.innerHeight);
        } else {
          window.scrollBy(0, -window.innerHeight);
          if(codError == '002H') { //clave de firma incorrecta
          }else if (codError == '089H') {
            this.datosFirma = null;
            this.mensajeError = 'Usuario bloqueado';
            window.scrollBy(0, -window.innerHeight);
          }else if(codError == '096H'){//si pide otp, quitamos los mensajes de error previos con confirmacion=null
            this.confirmacion=null;
            this.datosFirma = null;
            this.datosOTP=otp;
          }else{ //si es un error distinto del bloqueo de usuario o clave otp incorrecta, la otp se comporta como si la cancelaramos
            this.callBackCancelar(true); //true indica que hay un error de tx o servidor
          }
        }
      },
    callBackRellenarDatos(confirmacion, result){
      this.beforeSubmit = true;
      this.datosFirma = null;
      this.isBeforeSign=false;
      this.consultaRealizada=true;

      this.resultado=result;
      this.model.nombreUsuario=(result.data.data.typePhysicalPerson=="J") ? result.data.data.bussinesName : (result.data.data.name+(result.data.data.surname==null ? "" : " "+result.data.data.surname)+(result.data.data.secondSurname==null ? "" : " "+result.data.data.secondSurname));
      this.model.nifCif=result.data.data.legalDocument.id;
      if(result.data.data.addresses[0].streetType!=null){
        this.model.tipoVia=result.data.data.addresses[0].streetType.id;
        this.model.direccion=result.data.data.addresses[0].streetName;
      }
      this.model.numCallePlaza=result.data.data.addresses[0].streetNumber;
      this.model.codPostal=result.data.data.addresses[0].postcode;
      this.cargarProvincias();
      this.consultarDatosDomicilio(); //aqui consultamos los codigos de localidad y provincia, que la GPCONDAT no nos lo devuelve
      this.model.telefono=result.data.data.contactInfo.mobileNumber;
      this.model.fax=result.data.data.contactInfo.phoneNumber;
      this.model.emailNotiPago=result.data.data.contactInfo.email;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
     callBackCancelar(errorTx){
         this.beforeSubmit = true;
         this.datosFirma = null;
         this.datosOTP = null;
         if(this.consultaRealizada && this.confirmacion=='KO' && !errorTx){
           this.confirmacion=null; //elmina mensaje de error residual cuando clickamos en cancelar
           this.isBeforeSign=false; //mostramos botones de edicion
         }else if(this.consultaRealizada && this.confirmacion=='OK'){ //si ha modificado datos correctamente
          this.isBeforeSign=true; //volvemos al estado inicial
          this.consultaRealizada=false; //volvemos al estado inicial
         }else if(this.consultaRealizada){ //si ya ha realizado la primera consulta pero aun no ha modificado datos
          this.isBeforeSign=false; //mostramos botones de edicion
          //reseteamos datos
          if(this.resultado.data.data.addresses[0].streetType!=null){
            this.model.tipoVia=this.resultado.data.data.addresses[0].streetType.id;
              this.model.direccion=this.resultado.data.data.addresses[0].streetName;
            }
            this.model.numCallePlaza=this.resultado.data.data.addresses[0].streetNumber;
            this.model.codPostal=this.resultado.data.data.addresses[0].postcode;
            this.model.provincia=this.datosDomicilio.provincia;
            var ventana=this;
            setTimeout(function() { ventana.model.localidad=ventana.datosDomicilio.localidad; }, 500); //se hace con delay para que se ejecute primero el watcher del codigoPostal
            this.model.telefono=this.resultado.data.data.contactInfo.mobileNumber;
            this.model.emailNotiPago=this.resultado.data.data.contactInfo.email;
            this.model.fax=this.resultado.data.data.contactInfo.phoneNumber;
          }
      },
      toggle () {
        this.active = true;
        this.active2 = false;
        this.active3 = false;
      },
      toggle2 () {
        this.active = false;
        this.active2 = true;
        this.active3 = false;
      },
      toggle3 () {
        this.active = false;
        this.active2 = false;
        this.active3 = true;
      },
      pedirFIRMA() {////SE PIDE LA FIRMA
      const ventana=this;
      const baseURI = '/api-signatures/signatures';
      this.confirmacion=null;
      this.llamada = {
        urlEndpoint : '/api-customers/customers',
        metodo : 'GET'
      };
        
      let loader = this.$loading.show();
      this.$http.get(baseURI)
      .then((result) => {
        this.datosFirma =result.data.data;
        this.beforeSubmit = false
      })
      .catch(error => {
          if(error.response){ 
            if(error.response.status == 400) {
              if(error.response.data.result.errors[0].errorCode == "096H") {
                this.datosFirma = error.response.data.result.errors[0].info;
                this.beforeSubmit = false;
              }
            }else{ //si no, por defecto
              ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
              ventana.confirmacion='KO';
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
        })
      .then(function () {
        loader.hide();
      }); 
    },
    toggleeditar (numero,cancelar) {
      this.isBeforeSign=true;
      switch (numero){
        case 1:{
          this.editar1 = !this.editar1;
          if(cancelar){
            if(this.resultado.data.data.addresses[0].streetType!=null){
              this.model.tipoVia=this.resultado.data.data.addresses[0].streetType.id;
            }
            this.model.direccion=this.resultado.data.data.addresses[0].streetName;
            this.model.numCallePlaza=this.resultado.data.data.addresses[0].streetNumber;
            this.model.codPostal=this.resultado.data.data.addresses[0].postcode;
            this.model.provincia=this.datosDomicilio.provincia;
            var ventana=this;
            setTimeout(function() { ventana.model.localidad=ventana.datosDomicilio.localidad; }, 500); //se hace con delay para que se ejecute primero el watcher del codigoPostal
          }
          break;
        }
        case 3:{
          this.editar3 = !this.editar3;
          if(cancelar){
            this.model.telefono=this.resultado.data.data.contactInfo.mobileNumber;
          }
          break;
        }
        case 4:{
          this.editar4 = !this.editar4;
          this.model.emailNotiPago=this.resultado.data.data.contactInfo.email;
          break;
        }
        case 5:{
          this.editar5 = !this.editar5;
          this.model.fax=this.resultado.data.data.contactInfo.phoneNumber;
          break;
        }
      }
      if(cancelar){
        this.isBeforeSign=false;
      }
    },
    aceptar(numero) {////SE ENVIAN LOS DATOS AL SERVICIO
      this.submitted = true;
      this.$v.$touch();
      if(this.$v.$invalid) {
        return false;
      }else {
        const ventana=this;
        const baseURI = '/api-customers/customers';
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'PUT'
        };
        this.params = {
          'id': this.resultado.data.data.id,
          'legalDocument': this.resultado.data.data.legalDocument,
          "contactInfo": {
            "mobileNumber": this.resultado.data.data.contactInfo.mobileNumber!=this.model.telefono && numero==3 ? this.model.telefono : null, //el telefono solo se manda si se ha modificado
            "mobileNumberPrefix": {
              "id": this.resultado.data.data.contactInfo.mobileNumberPrefix ? this.resultado.data.data.contactInfo.mobileNumberPrefix.id : null,
              "name": "",
              "href": ""
            },
            "phoneNumberId": this.resultado.data.data.contactInfo && numero==5 ? this.resultado.data.data.contactInfo.phoneNumberId : null,
            "mobileNumberId": this.resultado.data.data.contactInfo && numero==3 ? this.resultado.data.data.contactInfo.mobileNumberId : null,
            //"faxNumberId": this.resultado.data.data.contactInfo && numero==5 ? this.resultado.data.data.contactInfo.faxNumberId : null,
            "phoneNumber": this.resultado.data.data.contactInfo!=this.model.fax && numero==5 ? this.model.fax : null, //el fijo solo se manda si se ha modificado el fax
            "phoneNumberPrefix": {
              "id": this.resultado.data.data.contactInfo.phoneNumberPrefix!=null ? this.resultado.data.data.contactInfo.phoneNumberPrefix.id : null,
              "name": "",
              "href": ""
            },/*
            "faxNumber": this.resultado.data.data.contactInfo!=this.model.fax && numero==5 ? this.model.fax : null, //el fax solo se manda si se ha modificado
            "faxNumberPrefix": {
              "id": this.resultado.data.data.contactInfo.faxNumberPrefix ? this.resultado.data.data.contactInfo.faxNumberPrefix.id : null,
              "name": "",
              "href": ""
            },*/
            /*"email": this.resultado.data.data.contactInfo.email!=this.model.emailNotiPago && numero==4 ? this.model.emailNotiPago : null, //el email solo se manda si se ha modificado
            "othersPhoneNumers": [
              {
                "type": "",
                "phoneNumber": "",
                "phoneNumberPrefix": {
                  "id": "",
                  "name": "",
                  "href": ""
                },
                "phoneNumberId": ""
              }
            ]*/
          },
          "addressId": numero==1 ? this.datosDomicilio.direccion : null,
          "country":"110", //se entiende que el portal es solo para residentes en spain, y el campo pais no figuraba en los funcionales, pero es necesario mandarlo para que no pete la tx
          "province": numero==1 ? this.model.provincia : null,
          "streetName": numero==1 ? this.model.direccion : null,
          "streetNumber": numero==1 ? this.model.numCallePlaza : null,
          "postcode": numero==1 ? this.model.codPostal : null,
          "city": numero==1 ? this.model.localidad : null,
          "streetType": numero==1 ? this.model.tipoVia : null,
          "isPrincipal":'true' //siempre utilizamos la residencia principal
        }
        //bloqueamos datos
        this.editar1=false;
        this.editar3=false;
        this.editar4=false;
        this.editar5=false;
        let loader = this.$loading.show();
        this.$http.put(baseURI, this.params)
        .then(() => {
          ventana.confirmacion='OK';
          window.scrollBy(0, -window.innerHeight);
          this.beforeSubmit=true;
          this.consultaRealizada=false;
          this.isBeforeSign=true;
        })
        
        .catch(error => {
                if(error.response){ 
                  if(error.response.status == 400) {
                    if(error.response.data.result.errors[0].errorCode == "096H") {
                      window.scrollBy(0, window.innerHeight);
                      if(error.response.data.result.errors[0].info.type=="OTP"){ //pide pin de OTP
                        ventana.datosOTP = error.response.data.result.errors[0].info;
                      }else{ //pide clave de firma
                        ventana.datosFirma = error.response.data.result.errors[0].info;
                      }
                      ventana.beforeSubmit = false;
                    }
                  }else{ //si no, por defecto
                    ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
                    ventana.confirmacion='KO';
                    ventana.beforeSubmit=true;
                    ventana.consultaRealizada=false;
                  }
                }else{ //si no, por defecto
                  ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
                  ventana.confirmacion='KO';
                  ventana.beforeSubmit=true;
                  ventana.consultaRealizada=false;
                }
              })
        .then(function () {
          loader.hide();
        });
      }
    },
  },
  watch: {
    watcherCodPostal() {
      if(this.model.codPostal.length==5){ //carga la poblacion siempre que cambie o rellenen un codigo postal
        this.model.localidad=null; //reseteamos esto para que no le deje mantener una poblacion que no concuerde con el cp
        this.cargarPoblacion(this.model.codPostal);
      }
    }
  }
}
</script>